const saveResults = {
  saveResultsButton: 'حفظ النتائج',
};

export default saveResults;
